import { api } from '../../utils/api'
import Notes from './Notes'

/**
 * OrderNotes: the shared Notes panel wired to one order's team notes, kept by
 * Prism. The Worker forwards the signed-in user, so the author is never sent
 * from here.
 */

export default function OrderNotes({ marketplace, orderNumber }) {
  const path = `/api/orders/${marketplace}/${orderNumber}/notes`
  return (
    <Notes
      sourceKey={`${marketplace}/${orderNumber}`}
      loadNotes={() => loadOrderNotes(path)}
      addNote={(text) => addOrderNote(path, text)}
      variant="thread"
    />
  )
}

async function loadOrderNotes(path) {
  const res = await api.get(path)
  return { notes: (res.notes || []).map(fromOrderNote) }
}

async function addOrderNote(path, text) {
  const saved = await api.post(path, { body: text })
  return fromOrderNote(saved)
}

function fromOrderNote(note) {
  return {
    id: note.order_note_id,
    author: note.created_by,
    createdAt: note.created_at,
    text: note.body,
    kind: note.kind
  }
}
